import React from "react";
import styled from "styled-components";
import { colors } from "../../../../theme";
import { POINTER_HOVER_MEDIA } from "../../../styles/pointer-hover";

//styles
const SummaryGrid = styled.section`
  display: grid;
  grid-template-columns: 1fr;
  gap: 2rem;
  margin-bottom: 40px;

  @media (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

const Column = styled.section`
  break-word: break-word;
`;

const Heading = styled.h2`
  font-size: 0.875rem;
  font-weight: 600;
  color: #111827;
  margin-bottom: 8px;
`;

const PortfolioItem = styled.div`
  margin-bottom: 12px;

  &:last-child {
    margin-bottom: 0;
  }
`;

const PortfolioLink = styled.a`
  display: block;
  color: ${colors.linkHover.light};
  text-decoration: none;
  font-weight: 500;
  transition: color 0.2s ease;

  @media ${POINTER_HOVER_MEDIA} {
    &:hover {
      color: ${colors.linkHover.dark};
      text-decoration: underline;
    }
  }

  &:focus-visible {
    outline: 2px solid
      color-mix(in srgb, ${colors.linkHover.light} 50%, transparent);
    outline-offset: 2px;
  }
`;

const PortfolioTech = styled.div`
  font-size: 1rem;
  color: #374151;
  margin-top: 0.25rem;
`;

const SkillsList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  list-style: none;
  padding: 0;
  margin: 0;
`;

const SkillTag = styled.li`
  display: inline-block;
  max-width: 100%;
  padding: 0.25rem 0.75rem;

  font-size: 0.75rem;
  line-height: 1.25;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  color: ${colors.linkHover.dark};
  background: ${colors.surface};

  border-radius: 9999px;
  border: 1px solid ${colors.form.border};

  list-style: none;

  &:focus-visible {
    outline: 2px solid
      color-mix(in srgb, ${colors.linkHover.light} 50%, transparent);
    outline-offset: 2px;
  }
`;

const PORTFOLIO_LINKS = [
  {
    id: "work-meltwater",
    label: "Meltwater Group",
    tech: "Stencil.js, TypeScript, Vue, HTML, SCSS, HTML5, Figma, MongoDB...",
  },
  {
    id: "work-speakeasy",
    label: "Speakeasy Events, Inc.",
    tech: "React, RedwoodJS, GraphQL, TypeScript, Agile, JSX...",
  },
  {
    id: "work-ziyang",
    label: "Ziyang Gong",
    tech: "React, TypeScript, JavaScript, Chakra UI, Context API, Material UI...",
  },
];

const navigateToAnchor = (anchorId) => (event) => {
  event.preventDefault();
  const nextHash = `#${anchorId}`;
  // pushState updates the URL without the browser's instant hash jump
  if (window.location.hash !== nextHash) {
    window.history.pushState(null, "", nextHash);
  }
  window.dispatchEvent(new Event("hashchange"));
};

export default function Summary() {
  return (
    <SummaryGrid id="Portfolio" data-testid="developer-main-highlights-section">
      {/* Portfolio */}
      <Column data-testid="portfolio-highlights-section">
        <Heading>Portfolio</Heading>

        {PORTFOLIO_LINKS.map((item) => (
          <PortfolioItem key={item.id}>
            <PortfolioLink
              href={`#${item.id}`}
              onClick={navigateToAnchor(item.id)}
            >
              {item.label}
            </PortfolioLink>
            <PortfolioTech>{item.tech}</PortfolioTech>
          </PortfolioItem>
        ))}
      </Column>

      {/* Experience */}
      <Column data-testid="experience-skills-section">
        <Heading>Experience</Heading>

        <SkillsList>
          <SkillTag>React - 7 years</SkillTag>
          <SkillTag>Vue - 4 years</SkillTag>
          <SkillTag>HTML5 - 7 years</SkillTag>
          <SkillTag>CSS - 7 years</SkillTag>
          <SkillTag>Next.js - 7 years</SkillTag>
          <SkillTag>TypeScript - 5 years</SkillTag>
          <SkillTag>Redux - 7 years</SkillTag>
          <SkillTag>GraphQL - 5 years</SkillTag>
        </SkillsList>
      </Column>
    </SummaryGrid>
  );
}
